export const HEADER_ID = "cards-slider-carousel-header";
